import { tv } from 'tailwind-variants';

const sheetStyles = tv({
    slots: {
        overlay: `
      iris:fixed
      iris:inset-0
      iris:z-[99]
      iris:bg-(--comp-color-background-sheet-scrim-default)
      iris:data-[state=closed]:[animation:fadeOut_var(--comp-motion-duration-bottom-sheet-exit)_var(--comp-motion-easing-bottom-sheet-exit)_forwards]
      iris:data-[state=open]:[animation:fadeIn_var(--comp-motion-duration-bottom-sheet-entry)_var(--comp-motion-easing-bottom-sheet-entry)_forwards]
      iris:md:data-[state=closed]:[animation:fadeOut_var(--comp-motion-duration-center-sheet-exit)_var(--comp-motion-easing-center-sheet-exit)_forwards]
      iris:md:data-[state=open]:[animation:fadeIn_var(--comp-motion-duration-center-sheet-entry)_var(--comp-motion-easing-center-sheet-entry)_forwards]
    `,
        contentWrapper: `
      iris:fixed
      iris:inset-0
      iris:top-[unset]
      iris:bottom-0
      iris:z-[100]
      iris:flex
      iris:justify-center
      iris:data-[state=closed]:[animation:bottomSheetOut_var(--comp-motion-duration-bottom-sheet-exit)_var(--comp-motion-easing-bottom-sheet-exit)_forwards]
      iris:data-[state=open]:[animation:bottomSheetIn_var(--comp-motion-duration-bottom-sheet-entry)_var(--comp-motion-easing-bottom-sheet-entry)_forwards]
      iris:max-md:items-end
      iris:md:top-0
      iris:md:bottom-[unset]
      iris:md:m-(--comp-space-padding-sheet-scrim-all)
      iris:md:data-[state=closed]:[animation:centerSheetOut_var(--comp-motion-duration-center-sheet-exit)_var(--comp-motion-easing-center-sheet-exit)_forwards]
      iris:md:data-[state=open]:[animation:centerSheetIn_var(--comp-motion-duration-center-sheet-entry)_var(--comp-motion-easing-center-sheet-entry)_forwards]
    `,
        content: `
      iris:relative
      iris:flex
      iris:h-fit
      iris:max-h-[calc(100vh-var(--comp-space-padding-bottom-sheet-scrim-top))]
      iris:w-full
      iris:flex-col
      iris:rounded-t-(--comp-size-radius-sheet)
      iris:bg-(--comp-color-background-sheet-sheet-default)
      iris:shadow-elevation-04
      iris:data-[state=closed]:[animation:bottomSheetOut_var(--comp-motion-duration-bottom-sheet-exit)_var(--comp-motion-easing-bottom-sheet-exit)_forwards]
      iris:data-[state=open]:[animation:bottomSheetIn_var(--comp-motion-duration-bottom-sheet-entry)_var(--comp-motion-easing-bottom-sheet-entry)_forwards]
      iris:md:max-h-[calc(100vh-2*var(--comp-space-padding-sheet-scrim-all))]
      iris:md:w-[unset]
      iris:md:rounded-b-(--comp-size-radius-sheet)
      iris:md:px-[unset]
      iris:md:data-[state=closed]:[animation:centerSheetOut_var(--comp-motion-duration-center-sheet-exit)_var(--comp-motion-easing-center-sheet-exit)_forwards]
      iris:md:data-[state=open]:[animation:centerSheetIn_var(--comp-motion-duration-center-sheet-entry)_var(--comp-motion-easing-center-sheet-entry)_forwards]
    `,
        header: `
      iris:flex
      iris:px-(--comp-space-padding-sheet-header-horizontal)
      iris:py-(--comp-space-padding-sheet-header-vertical)
      iris:font-(family-name:--comp-type-font-sheet-title)
    `,
        title: `
      iris:pr-(--comp-size-icon-sheet-header)!
      iris:text-(length:--comp-type-size-sheet-title-mobile)
      iris:leading-(--comp-type-leading-sheet-header-title)
      iris:font-(--comp-type-weight-sheet-title)
      iris:tracking-(--comp-type-tracking-sheet-title)
      iris:text-(--comp-color-content-sheet-title)
      iris:md:text-(length:--comp-type-size-sheet-title-desktop)
    `,
        close: `
      iris:m-(--base-space-px-8)
      iris:rounded-(--comp-size-radius-sheet-control-button)
      iris:bg-(--comp-color-background-sheet-header-icon-rest)
      iris:hover:bg-(--comp-color-background-sheet-header-icon-hover)
      iris:active:bg-(--comp-color-background-sheet-header-icon-pressed)
    `,
        iconClass: `
      iris:text-(--comp-color-content-sheet-header-icon-rest)
      iris:group-hover:text-(--comp-color-content-sheet-header-icon-hover)
      iris:group-active:text-(--comp-color-content-sheet-header-icon-pressed)
    `,
        backIconBox: `
      iris:rounded-(--comp-size-radius-sheet-control-button)
      iris:bg-(--comp-color-background-sheet-header-icon-rest)
      iris:hover:bg-(--comp-color-background-sheet-header-icon-hover)
      iris:active:bg-(--comp-color-background-sheet-header-icon-pressed)
    `,
        body: `
      iris:flex
      iris:h-full
      iris:w-full
      iris:flex-col
      iris:items-center
      iris:self-center
      iris:overflow-auto
      iris:p-(--comp-space-padding-bottom-sheet-all)
      iris:pt-[unset]
      iris:md:px-(--comp-space-padding-center-sheet-horizontal)
      iris:md:pb-(--comp-space-padding-center-sheet-bottom)
    `,
        footerSheet: ``,
    },
    variants: {
        desktopPosition: {
            right: {
                overlay: `
          iris:pl-(--comp-space-padding-sheet-scrim-all)
          iris:md:data-[state=closed]:[animation:fadeOut_var(--comp-motion-duration-side-sheet-exit)_var(--comp-motion-easing-side-sheet-exit)_forwards]
          iris:md:data-[state=open]:[animation:fadeIn_var(--comp-motion-duration-side-sheet-entry)_var(--comp-motion-easing-side-sheet-entry)_forwards]
        `,
                contentWrapper: `
          iris:inset-0
          iris:top-[unset]
          iris:md:right-0
          iris:md:left-[unset]
          iris:md:mt-0
          iris:md:mr-0
          iris:md:h-full
          iris:md:w-[1024px]
          iris:md:max-w-[calc(100vw-360px)]
          iris:md:justify-end
          iris:md:p-0
          iris:md:data-[state=closed]:[animation:rightSheetOut_var(--comp-motion-duration-side-sheet-exit)_var(--comp-motion-easing-side-sheet-exit)_forwards]
          iris:md:data-[state=open]:[animation:rightSheetIn_var(--comp-motion-duration-side-sheet-entry)_var(--comp-motion-easing-side-sheet-entry)_forwards]
        `,
                content: `
          iris:md:h-full
          iris:md:max-h-[100vh]
          iris:md:min-w-[360px]
          iris:md:rounded-[unset]
          iris:md:data-[state=closed]:[animation:rightSheetOut_var(--comp-motion-duration-side-sheet-exit)_var(--comp-motion-easing-side-sheet-exit)_forwards]
          iris:md:data-[state=open]:[animation:rightSheetIn_var(--comp-motion-duration-side-sheet-entry)_var(--comp-motion-easing-side-sheet-entry)_forwards]
        `,
            },
            left: {
                overlay: `
          iris:pr-(--comp-space-padding-sheet-scrim-all)
          iris:md:data-[state=closed]:[animation:fadeOut_var(--comp-motion-duration-side-sheet-exit)_var(--comp-motion-easing-side-sheet-exit)_forwards]
          iris:md:data-[state=open]:[animation:fadeIn_var(--comp-motion-duration-side-sheet-entry)_var(--comp-motion-easing-side-sheet-entry)_forwards]
        `,
                contentWrapper: `
          iris:top-[unset]
          iris:md:right-[unset]
          iris:md:left-0
          iris:md:mt-0
          iris:md:ml-0
          iris:md:h-full
          iris:md:w-fit
          iris:md:max-w-[calc(100vw-360px)]
          iris:md:justify-start
          iris:md:p-0
          iris:md:data-[state=closed]:[animation:leftSheetOut_var(--comp-motion-duration-side-sheet-exit)_var(--comp-motion-easing-side-sheet-exit)_forwards]
          iris:md:data-[state=open]:[animation:leftSheetIn_var(--comp-motion-duration-side-sheet-entry)_var(--comp-motion-easing-side-sheet-entry)_forwards]
        `,
                content: `
          iris:md:h-full
          iris:md:max-h-[100vh]
          iris:md:min-w-[360px]
          iris:md:rounded-[unset]
          iris:md:data-[state=closed]:[animation:leftSheetOut_var(--comp-motion-duration-side-sheet-exit)_var(--comp-motion-easing-side-sheet-exit)_forwards]
          iris:md:data-[state=open]:[animation:leftSheetIn_var(--comp-motion-duration-side-sheet-entry)_var(--comp-motion-easing-side-sheet-entry)_forwards]
        `,
            },
            center: ``,
        },
        fixedButtons: {
            true: {
                contentWrapper: `
          iris:max-md:h-[calc(100vh-var(--comp-space-padding-bottom-sheet-scrim-top))]
        `,
                content: "iris:h-full",
                footerSheet: `
          iris:border-t
          iris:border-t-(--comp-color-border-sheet-default)
          iris:bg-(--comp-color-background-sheet-sheet-default)
          iris:p-(--comp-space-padding-bottom-sheet-all)
          iris:md:rounded-b-(--comp-size-radius-sheet)
          iris:md:px-(--comp-space-padding-center-sheet-horizontal)
          iris:md:py-(--comp-space-padding-sheet-footer-vertical)
        `,
            },
            false: {},
        },
        hasHeader: {
            true: {
                header: `
          iris:items-center
          iris:justify-between
          iris:rounded-t-(--comp-size-radius-sheet)
          iris:border-b
          iris:border-b-(--comp-color-border-sheet-default)
          iris:bg-(--comp-color-background-sheet-sheet-default)
        `,
                body: `
          iris:pt-(--base-space-px-16)
          iris:pb-(--base-space-px-24)
        `,
                title: `
          iris:text-(length:--comp-type-size-sheet-header-title)
          iris:font-(--comp-type-weight-sheet-header-title)
          iris:tracking-(--comp-type-tracking-sheet-header-title)
          iris:text-(--comp-color-content-sheet-header-title)
          iris:md:text-(length:--comp-type-size-sheet-header-title)
        `,
                close: "iris:m-[unset]",
            },
            false: {
                header: `
          iris:px-[unset]
          iris:py-[unset]
        `,
                title: `
          iris:py-(--comp-space-padding-sheet-header-vertical)
          iris:pl-(--comp-space-padding-bottom-sheet-all)
          iris:leading-[unset]
          iris:md:px-(--comp-space-padding-center-sheet-horizontal)
          iris:md:pt-(--comp-space-padding-center-sheet-top)
          iris:md:pb-(--base-space-px-8)
        `,
                close: `
          iris:absolute
          iris:right-0
        `,
            },
        },
        showBackArrow: {
            true: {},
            false: {
                backIconBox: "iris:invisible",
            },
        },
        modal: {
            true: {},
            false: {
                overlay: `
          iris:block
          iris:hidden
        `,
                contentWrapper: `
          iris:max-md:h-fit
          iris:max-md:max-h-[calc(100vh-var(--comp-space-padding-bottom-sheet-scrim-top))]
        `,
                content: "iris:max-md:h-fit",
            },
        },
        hasTitle: {
            true: {},
            false: {},
        },
    },
    compoundVariants: [
        {
            hasHeader: false,
            hasTitle: false,
            class: {
                body: `
          iris:pt-(--comp-space-padding-bottom-sheet-all)
          iris:md:pt-(--comp-space-padding-center-sheet-top)
        `,
            },
        },
    ],
});

export { sheetStyles as default };
